import CitySEOHead from "@/components/feature/CitySEOHead";
import KeyLargoHeroSection from "./components/HeroSection";
import KeyLargoStickyNav from "./components/StickyNav";
import KeyLargoProcessingTimeSection from "./components/ProcessingTimeSection";
import KeyLargoServicesSection from "./components/ServicesSection";
import KeyLargoLocalAreaSection from "./components/LocalAreaSection";
import KeyLargoTravelTimingSection from "./components/TravelTimingSection";
import KeyLargoDestinationsSection from "./components/DestinationsSection";
import KeyLargoTestimonialsSection from "./components/TestimonialsSection";
import KeyLargoAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import KeyLargoComparisonSection from "./components/ComparisonSection";
import KeyLargoMistakesSection from "./components/MistakesSection";
import KeyLargoHowItWorksSection from "./components/HowItWorksSection";
import KeyLargoFAQSection, { faqs } from "./components/FAQSection";
import KeyLargoHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import KeyLargoFinalCTA from "./components/FinalCTA";

const keyLargoServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function KeyLargoPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Key Largo"
        state="Florida"
        stateAbbr="FL"
        route="/cities/key-largo"
        title="Emergency Passport Key Largo, FL — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Key Largo, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Monroe County, the Florida Keys, divers, boaters, and travelers."
        geoPlacename="Key Largo, Florida"
        geoPosition="25.0865;-80.4473"
        faqs={faqs}
        servicesSchema={keyLargoServices}
      />
      <KeyLargoHeroSection />
      <KeyLargoStickyNav />
      <KeyLargoProcessingTimeSection />
      <KeyLargoServicesSection />
      <KeyLargoLocalAreaSection />
      <KeyLargoTravelTimingSection />
      <KeyLargoDestinationsSection />
      <KeyLargoTestimonialsSection />
      <KeyLargoAcceptanceFacilitiesSection />
      <KeyLargoComparisonSection />
      <KeyLargoMistakesSection />
      <KeyLargoHowItWorksSection />
      <KeyLargoFAQSection />
      <KeyLargoHelpfulResourcesSection />
      <KeyLargoFinalCTA />
    </div>
  );
}